/**
 * Merge a fresh contact lookup into the wizard lists.
 * New ids are appended and selected. Existing ids keep their checked state.
 *
 * @param {Array} previousContacts
 * @param {Array} selectedContacts
 * @param {Array} fetchedContacts
 * @returns {{ contacts: Array, selectedContacts: Array, added: Array }}
 */
export function mergeDetectedContacts(previousContacts, selectedContacts, fetchedContacts) {
  const previous = Array.isArray(previousContacts) ? previousContacts : [];
  const selected = Array.isArray(selectedContacts) ? selectedContacts : [];
  const fetched = Array.isArray(fetchedContacts) ? fetchedContacts : [];

  const knownIds = new Set(previous.map((contact) => contact?._id).filter(Boolean));
  const selectedIds = new Set(selected.map((contact) => contact?._id).filter(Boolean));
  const added = [];
  const newlySelected = [];

  for (const contact of fetched) {
    const id = contact?._id;
    if (!id || knownIds.has(id)) continue;
    knownIds.add(id);
    added.push(contact);
    if (!selectedIds.has(id)) {
      selectedIds.add(id);
      newlySelected.push(contact);
    }
  }

  return {
    contacts: [...previous, ...added],
    selectedContacts: [...selected, ...newlySelected],
    added,
  };
}
